import { types } from './actions.js'

const initialState = { }

function upsert(name, state) {
  if (!state[name]) {
    return {
      ...state,
      [name]: {}
    }
  }
  return {
    ...state,
    [name]: {...state[name]}
  }
}

function registerModal(state, action) {
  const name = action.name
  const nState = upsert(name, state)
  const modal = nState[name]
  if (!modal.count) {
    nState[name] = {
      open: false,
      closing: false,
      count: 1,
      version: 0,
      initialState: {}
    }
  } else {
    modal.count++
  }
  return nState
}

function unregisterModal(state, action) {
  const name = action.name
  const nState = upsert(name, state)
  const modal = nState[name]
  if (!modal.count || (modal.count - 1) <= 0) {
    delete nState[name]
  } else {
    modal.count--
  }
  return nState
}

function openModal(name, modalState = {}, state) {
  return {
    ...state,
    [name]: {
      ...state[name],
      open: true,
      initialState: modalState
    }
  }
}

function closeModal(name, state) {
  const currentVersion = state[name]?.version ?? 0
  return {
    ...state,
    [name]: {
      ...state[name],
      open: false,
      closing: false,
      version: currentVersion + 1,
    }
  }
}

function preCloseModal(name, state) {
  return {
    ...state,
    [name]: {
      ...state[name],
      closing: true
    }
  }
}

function cancelCloseModal(name, state) {
  return {
    ...state,
    [name]: {
      ...state[name],
      closing: false
    }
  }
}

function closeAllModals(state) {
  return Object.keys(state).map((name) => {
    const currentVersion = state[name]?.version ?? 0
    return {
      ...state[name],
      open: false,
      version: currentVersion + 1
    }
  })
}

export default function reducer(state = initialState, action) {
  if (action.type === types.REGISTER_MODAL) {
    return registerModal(state, action)
  } else if (action.type === types.UNREGISTER_MODAL) {
    return unregisterModal(state, action)
  } else if (action.type === types.OPEN_MODAL) {
    return openModal(action.name, action.initialState, state)
  } else if (action.type === types.CLOSE_MODAL) {
    return closeModal(action.name, state)
  } else if (action.type === types.CANCEL_CLOSE_MODAL) {
    return cancelCloseModal(action.name, state)
  } else if (action.type === types.PRE_CLOSE_MODAL) {
    return preCloseModal(action.name, state)
  } else if (action.type === types.CLOSE_ALL_MODALS) {
    return closeAllModals(state)
  }
  return state
}